<template>
    <section>
        <PageTitle title="All Areas" v-if="!hidePageTitle" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/areas',title:'Areas'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-md-12">
                    <div class="ibox-title">
                        <h5 class="pull-left">All Areas</h5>
                        <a v-on:click="addArea()" class="pull-right" >Add New Area</a>
                        <a v-if="userRole==='ROLE_ADMIN' || userRole==='ROLE_MANAGER'" v-on:click="addCities()" class="pull-right" style="margin-right:20px;">Add Cities</a>
                    </div>
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Cities</label>
                                    <multiselect id="filter1" v-model="selectedCityId" :options="cities" label="city" track-by="city"></multiselect>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Area Name</label>
                                    <input v-model="areaName" placeholder="Area Name..." id="filter2" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Branch Area</label>
                                  <select v-model="branchArea" id="branch_area" class="form-control">
                                    <option value="No">NO</option>
                                    <option value="Yes">YES</option>
                                    <option value="All">ALL</option>
                                  </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_area_btn" type="button"><i class="fa fa-search"></i> Search</button>
                                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_area_btn" type="button"><i class="fa fa-refresh"></i> Refresh</button>
                            </div>                          
                        </div>
                        <hr/>
                        <div class="table-responsive">
                            <table class="table table-striped table-responsive table-bordered table-hover" id="dtAreaTable">
                                <thead>
                                    <tr>
                                        <th>Area ID</th>
                                        <th>Name</th>
                                        <th>Longitude</th>
                                        <th>Latitude</th>
                                        <th>City</th>
                                        <th>Branch Area</th>
                                        <th>Approved</th>
                                        <th class="text-center"><i class="fa fa-bolt"></i></th>
                                    </tr>
                                </thead>
                                <tbody />
                            </table>
                        </div>                        
                    </div>
                </div>

            </div>
        </div>
        <AddUpdateArea ref="AddUpdateArea"></AddUpdateArea>
        <AddUpdateCities ref="AddUpdateCities"></AddUpdateCities>
        <RestaurantAreaDeliveryFee
            ref="restaurantAreaDeliveryFeeComponent"
            :restaurants="restaurants"
        />
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from '@/components/layout_components/PageTitle'
    import Multiselect from 'vue-multiselect'
    import AddUpdateArea from '@/components/areas/AddUpdateArea'
    import AddUpdateCities from '@/components/areas/AddUpdateCities'
    import RestaurantAreaDeliveryFee from "@/components/areas/RestaurantAreaDeliveryFee.vue";

    export default {
        name: "Areas",
        components: {
            RestaurantAreaDeliveryFee,
            PageTitle,
            AddUpdateArea,
            AddUpdateCities,
            Multiselect
        },
        data() {
            return {
                cities:[],
                restaurants: [],
                selectedCityId:'',
                areaName:'',
                branchArea:'All',
                userRole:''
            }
        },
      props: {
        hidePageTitle: {
          type: Boolean,
          default: false,
        }
      },
        mounted: async function () {
            let user = this.$store.state.user;
            this.userRole = user.userRolesById[0].role;
            this.$http.post(this.$store.state.mainAppURL + "areas/get_all_cities").then(resp => {
                this.cities = resp.data;
            });
            let self = this;
            let processingURL = this.$store.state.mainAppURL + "areas/get_all_areas";
            let dtAreaTable = $('#dtAreaTable').DataTable({
                "createdRow": function (row, data, index) {
                    if (data.deleted === true) {
                        $(row).hide();
                    }
                },
                "processing": true,
                "serverSide": true,
                "searching": true,
                autoWidth: false,
                "lengthMenu": [10, 25, 50, 100, 250],
                "initComplete": function () {
                    var api = this.api();
                    if (self.userRole === 'ROLE_AGENT') {
                        api.column(7).visible(false);
                    }
                },
                "order": [[0, "desc"]],
                'language': {
                    //'loadingRecords': 'Please wait - loading...',
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function (d) {
                        return JSON.stringify(d);
                    },
                    headers: {
                        "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend: (xhr) => {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                        401: () => {
                            this.updateRefreshTokenInDataTable(dtAreaTable);
                        }
                    }
                },
                "columnDefs": [
                    {"orderable": false, "targets": [1, 2, 3, 4, 5, 6]},
                    {'className': "text-center", 'aTargets': [0, 1, 2, 3, 4, 5]},
                ],
                "columns": [
                    {"data": "id", "name": "id"},
                    {"data": "name", "name": "name"},
                    {"data": "lng", "name": "lng"},
                    {"data": "lat", "name": "lat"},
                    {
                        "data": "citiesByCityId", "name": "City",
                        "render": function (data) {
                            return data && data.city;
                        }
                    },
                    {
                        "data": "isBranch", "name": "isBranch",
                        "render": function (data) {
                            return (data === false) ? "No" : "Yes";
                        }
                    },
                    {
                        "data": "approved", "name": "approved",
                        "render": function (data) {
                            return (data === true) ? "Approved" : "Pending"
                        }
                    },
                    {
                        "data": "action", "name": "action",
                        "render": function (data, type, row) {
                            let html = "<div class='text-center'>"
                            if (!row.approved) {
                                html += "<a data-id='" + row.id + "' class='approveBtn'><i title='Approve' class='fa fa-check fa-lg'></i></a> |";
                            }
                            if (!row.isBranch) {
                                html += "<a data-id='" + row.id + "' data-name='" + row.name + "'  class='restaurantAreaDeliveryFeeBtn'><i title='Delivery Fee' class='fa fa-gear fa-lg'></i></a> |";
                            }
                            html += "<a data-id='" + row.id + "' class='deleteAreaBtn'><i title='Delete' class='fa fa-remove fa-lg'></i></a>|<a data-id='" + row.id + "' class='updateAreaBtn'><i title='Edit' class='fa fa-pencil fa-lg'></i></a></div>"
                            return html;
                        }
                    }
                ],
                "drawCallback": function (settings) {
                    $(".m_tip").tooltip();
                    $(".updateAreaBtn").click(function () {
                        let areaId = $(this).attr("data-id");
                        self.$refs.AddUpdateArea.loadForUpdate(self.cities, areaId);
                    });
                    $(".approveBtn").click(function () {
                        let areaId = $(this).attr("data-id");
                        Swal.fire({
                            title: 'Please Wait! We are processing the data.',
                            type: 'info',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            onBeforeOpen: () => {
                                Swal.showLoading();
                            },
                        });
                        self.$http.get(self.$store.state.mainAppURL + "areas/approve_area/" + areaId).then(resp => {
                            Swal.close();
                            dtAreaTable.draw();
                            swal("Saved!", " Approved", "success");

                        });
                    });
                    $(".deleteAreaBtn").click(function () {
                        let areaId = $(this).attr("data-id");
                        Swal({
                            title: 'Are you sure?',
                            text: "Are you sure you want to delete this area!",
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#1ab394',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, delete it!'
                        }).then((result) => {
                            if (result.value) {
                                self.$http.delete(self.$store.state.mainAppURL + "areas/" + areaId).then(resp => {
                                    Swal.close();
                                    if (resp.data) {
                                        dtAreaTable.draw();
                                        swal("SUCCESS!", "Area has been deleted successfully!", "success");
                                    } else {
                                        swal("Error!", "Please try again!", "error");
                                    }
                                }).catch(ex => {
                                    swal("Error!", ex + "Please try again!!", "error");
                                });
                            }
                        });
                    });
                    $(".restaurantAreaDeliveryFeeBtn").click(function () {
                        let areaId = $(this).attr("data-id");
                        let areaName = $(this).attr("data-name");
                        self.$refs.restaurantAreaDeliveryFeeComponent.loadBranchDeliveryFeeDetails(areaId, areaName)
                    });
                },
                "tableTools": {
                    "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
                }
            });
            this.table = dtAreaTable;
            $.fn.dataTable.ext.errMode = 'none';
            $(".search_area_btn").click(function () {
                dtAreaTable.search('');
                dtAreaTable.column(1).search(self.areaName);
                dtAreaTable.column(4).search(self.selectedCityId.id);
                dtAreaTable.column(5).search(self.branchArea);
                dtAreaTable.draw();
            });
            $(".refresh_area_btn").click(function () {
                dtAreaTable.column(1).search('');
                dtAreaTable.column(4).search('');
                dtAreaTable.column(5).search('All');
                dtAreaTable.draw();
                self.selectedCityId = '';
                self.areaName = '';
                self.branchArea = 'All';

            });
            let dtTableFilterSelector = $("#dtAreaTable_filter input");
            dtTableFilterSelector.unbind();
            dtTableFilterSelector.attr("size", "35");
            dtTableFilterSelector.attr("placeholder", "Search On Area ID, Name or City");
            dtTableFilterSelector.keyup(function (e) {
                if (e.keyCode === 13) {
                    dtAreaTable.search($(this).val()).draw();
                }
            });
            this.restaurants = await this.fetchAllRestaurants();
        },
        methods:{
            addArea: function(){
                this.$refs.AddUpdateArea.load(this.cities);
            },
            addCities: function(){
                this.$refs.AddUpdateCities.load();
            },
            tableDraw: function () {this.table.draw()},
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
